module.exports = __webpack_public_path__ + "img/paypal.7012f679.png";